export default "__VITE_ASSET__CdXPd9d2__"